<!---===================== MODAL CONTEXT MENU RIGHT CLICK =====================--->
<div class="Context-Menu" id="Context-Menu">

  <ul>

    <li (click)="ToggleModalRename(true); Close_Context_Menu()" class="Item-Context"
    *ngIf="(UserRoleIn([PermissionFIN.renameFile]) && !FFIN_Select_CM.Directory) || (UserRoleIn([PermissionFIN.renameFolder]) && FFIN_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])">
      <i class="fa-regular fa-pen-to-square"></i>
      <span class="Text-Item">Renombrar</span>
    </li>

    <li (click)="SelectForMoveEvent.emit(FFIN_Select_CM); Close_Context_Menu()" class="Item-Context"
    *ngIf="(UserRoleIn([PermissionFIN.moveFile]) && !FFIN_Select_CM.Directory) || (UserRoleIn([PermissionFIN.moveFolder]) && FFIN_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])">
      <i class="fa-solid fa-up-down-left-right"></i>
      <span class="Text-Item">Mover</span>
    </li>




    <li [routerLink]="['/Dashboard/FIN/ShareFolderF', FFIN_Select_CM.ID]" class="Item-Context"
    *ngIf="(UserRoleIn([PermissionFIN.sharedFolder]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]) ) && FFIN_Select_CM.Directory">
      <i class="fa-solid fa-share-nodes"></i>
      <span class="Text-Item">Compartir</span>
    </li>


    <li *ngIf="CanSeeVersionHistory()" (click)="See_version_History(); Close_Context_Menu()" class="Item-Context">
      <i class="fa-solid fa-arrow-up-right-dots"></i>
      <span class="Text-Item">Historial de Versiones</span>
    </li>
    <li (click)="ToggleModalProperties(true); Close_Context_Menu()" class="Item-Context"
    *ngIf="(UserRoleIn([PermissionFIN.properties]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) && !FFIN_Select_CM.Directory">
      <i class="fa-solid fa-file-pen"></i>
      <span class="Text-Item">Propiedades</span>
    </li>
    <li (click)="Delete_File_or_Directory(); Close_Context_Menu()" class="Item-Context"
    *ngIf="(UserRoleIn([PermissionFIN.deleteFile]) && !FFIN_Select_CM.Directory) || (UserRoleIn([PermissionFIN.deleteFolder]) && FFIN_Select_CM.Directory) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])">
      <i class="fa-regular fa-trash-can"></i>
      <span class="Text-Item">Borrar</span>
    </li>

    <div class="separatorbar"></div>
    <li (click)="PreviewFileEvent.emit(FFIN_Select_CM); Close_Context_Menu()" class="Item-Context" *ngIf="!FFIN_Select_CM.Directory && CanDownloadCM()">
      <i class="fa-solid fa-eye"></i>
      <span class="Text-Item">Vista Previa</span>
    </li>

    <li (click)="this.SeeFolder_BreadCrum(this.NumberTopL); Close_Context_Menu()" class="Item-Context">
      <i class="fa-solid fa-arrows-rotate"></i>
      <span class="Text-Item">Recargar Pagina</span>
    </li>

    <li (click)="DownloadFile(); Close_Context_Menu()" class="Item-Context" *ngIf="!FFIN_Select_CM.Directory && CanDownloadCM()">
      <i class="fa-solid fa-cloud-arrow-down"></i>
      <span class="Text-Item">Descargar</span>
    </li>

    <li (click)="Close_Context_Menu()" class="Item-Context"><i class="fa-solid fa-xmark"></i>
      <span class="Text-Item">Cerrar</span>
    </li>

  </ul>
</div>

<!---===================== MODAL FOR RENAME FILE OR DIRECTORY =====================--->
<section class="Modal-Global" id="ModalRenameFD">
  <div class="wrapper">
    <div class="Pro-popup3 popup">
      <div class="Pro-inside3 popup-inside">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormRenameFD" (ngSubmit)="RenameFD()">
        <div class="Pro-content3 content">
          <div class="Btn-Close" (click)="ToggleModalRename(false)"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2 *ngIf="this.FFIN_Select_CM.Directory">Renombrar Carpeta</h2>
            <h2 *ngIf="!this.FFIN_Select_CM.Directory">Renombrar Proceso</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre
              </div>
              <div class="Container-input Input-Text-Form" id="IdInputCodeNewCDMS">
                <i class="fa-solid fa-signature"></i><input type="text" formControlName="NameRename">
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
              <i class="fa-solid fa-signature"></i><span class="text">Renombrar</span>
            </button>
            <div (click)="ToggleModalRename(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>


<app-properties-proc-fin (IsAnnexeUpdaFIN)="isUpdateAnnexe($event)" (IsPropertiesFIN)="IsCompleteProperties($event)" [Permission_FMF]="this.Permission_FMF"
  [FileAuxPropeties_Anne]="this.FileAuxPropeties_Anne" [FFIN_Select_CM]="this.FFIN_Select_CM"
  [FILE_FIN_Properties]="this.FILE_FIN_Properties" [FormFINProperties]="this.FormFINProperties"
  [All_FAF_FIN]="this.All_FAF_FIN"></app-properties-proc-fin>


<!---===================== MODAL FOR REASON FOR REJECTION =====================--->
<section class="Modal-Global" id="ModalReject">
  <div class="wrapper">
    <div class="Pro-popup1 popup">
      <div class="Pro-inside1 popup-inside">
        <div class="Pro-backgrounds1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <form [formGroup]="FormReject" (ngSubmit)="SaveReject()">
        <div class="Pro-content1 content Content_Custom">
          <div (click)="ToggleModalReasonReject(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
          <div class="Content-Top">
            <h2>Rechazar proceso</h2>
            <h4>Escribe la razón de rechazo del proceso</h4>
          </div>

          <div class="Content-body">
            <div class="Content-grid-1">
              <div class="Container-input Text-Area-Form">
                <i class="fa-solid fa-signature"></i><textarea id="IdTextAreaRejectFIN" formControlName="ReasonText"
                  placeholder="Razón de rechazo ..."></textarea>
              </div>
            </div>

          </div>
          <div class="Content-Bottom">
            <button type="submit" class="Btn-LSave-Form1 btn-icon-text">
              <i class="fa-solid fa-location-arrow"></i><span class="text">Enviar</span>
            </button>
            <div (click)="ToggleModalReasonReject(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</section>